/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './video-detail.stache';
import can from 'can';
import urlUtil from 'scripts/utils/url';
import settings from 'scripts/utils/settings';

const module =
    window.globalSettings.pageType === 'video-highlights' && 'highlights';
const moduleSettings = settings.getModuleSettings(module, {
    isEnabled: true,
    unavailabilityMessage: '',
});
const isModuleEnabled = moduleSettings.isEnabled;
const disabledMessage = moduleSettings.unavailabilityMessage;

const isFeaturedPage = () => {
    const featuresSegment = '/features';
    return window.location.href.search(featuresSegment) > -1;
};

const getPageType = () => {
    if (isFeaturedPage()) {
        return 'featured';
    }

    return 'highlights';
};

Component.extend({
    tag: 'video-detail',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            disabledMessage: {
                type: 'string',
                value: disabledMessage,
            },
            type: {
                type: 'string',
                Value: null,
            },
            tabs: {
                Type: can.List,
                Value: null,
            },
            sponsor: {
                Type: can.Map,
                Value: null,
            },
            activeCard: {
                Type: can.Map,
                Value: null,
            },
            videoCards: {
                Type: can.List,
                Value: can.List,
            },
            dtmTrack: {
                type: 'boolean',
                value: false,
            },
            dtmVideoLocation: {
                type: 'string',
                value: 'Video Detail Page',
            },
            isEnabled: {
                get() {
                    return isFeaturedPage() || isModuleEnabled;
                },
            },
            showFeed: {
                type: 'boolean',
                value: true,
            },
        },
    },
    events: {
        inserted() {
            const type = getPageType();
            this.viewModel.attr('type', type);
        },
        '{scope} activeCard'(scope, event, card) {
            can.$('html,body').animate({ scrollTop: 0 }, '500');
            document.title = card.title;
            urlUtil.pushState(card.shareUrl);
        },
    },
});
